import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, XCircle } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isDestructive = variant === "destructive"

        return (
          <Toast
            key={id}
            variant={variant}
            {...props}
            className="bg-white border-[rgba(15,23,42,0.10)] shadow-[0_12px_40px_rgba(15,23,42,0.12)] rounded-[14px] px-3.5 py-3 gap-3 max-w-[400px]"
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                  isDestructive
                    ? "bg-[rgba(220,38,38,0.12)]"
                    : "bg-[rgba(37,99,235,0.12)]"
                }`}
              >
                {isDestructive ? (
                  <XCircle className="h-4 w-4 text-[#DC2626]" />
                ) : (
                  <CheckCircle2 className="h-4 w-4 text-[#2563EB]" />
                )}
              </div>
              <div className="grid gap-0.5">
                {title && (
                  <ToastTitle className="text-[14px] font-semibold text-[#0F172A]">
                    {title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription className="text-[13px] text-[rgba(15,23,42,0.70)]">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
